import './NewsAllPage.css';
import newsImage1 from './assets/news/news1.jpg';
import newsImage2 from './assets/news/new2.jpg';
import newsImage3 from './assets/news/news3.jpg';
import newsImage4 from './assets/news/news4.jpg';
import newsImage5 from './assets/news/news5.jpg';
import newsImage6 from './assets/news/news6.jpg';
import newsImage7 from './assets/news/news7.jpg';
import newsImage8 from './assets/news/news8.jpg';

const highlightPhotos = [
  newsImage1,
  newsImage2,
  newsImage3,
  newsImage4,
  newsImage5,
  newsImage6,
  newsImage7,
  newsImage8,
];

const allNewsData = {
  en: [
    {
      id: 1,
      date: 'April 12, 2026',
      title: 'Parent orientation week begins',
      image: highlightPhotos[2],
    },
    {
      id: 2,
      date: 'April 18, 2026',
      title: 'Student talent showcase',
      image: highlightPhotos[3],
    },
    {
      id: 3,
      date: 'April 24, 2026',
      title: 'Community service collaboration',
      image: highlightPhotos[4],
    },
  ],
  id: [
    {
      id: 1,
      date: '12 April 2026',
      title: 'Minggu orientasi orang tua dimulai',
      image: highlightPhotos[2],
    },
    {
      id: 2,
      date: '18 April 2026',
      title: 'Pentas bakat siswa',
      image: highlightPhotos[3],
    },
    {
      id: 3,
      date: '24 April 2026',
      title: 'Kolaborasi layanan masyarakat',
      image: highlightPhotos[4],
    },
  ],
};

function NewsAllPage({ language = 'en' }) {
  const allNews = allNewsData[language];

  return (
    <div className="news-all-page">
      <div className="news-all-container">
        <header className="news-all-header">
          <h1>{language === 'en' ? 'Latest News & Updates' : 'Berita & Pembaruan Terkini'}</h1>
          <p>{language === 'en' ? 'Stay informed with the latest happenings at Permata Harapan School' : 'Tetap terinformasi dengan berita terbaru di Permata Harapan School'}</p>
        </header>

        <div className="news-all-grid">
          {allNews.map((news) => (
            <article 
              key={news.id}
              className="news-all-card"
              onClick={() => {
                window.location.hash = `#news/${news.id}`;
                window.location.reload();
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  window.location.hash = `#news/${news.id}`;
                  window.location.reload();
                }
              }}
            >
              <div className="news-all-card-image-wrap">
                <img 
                  src={news.image} 
                  alt={news.title}
                  className="news-all-card-image"
                />
              </div>
              <div className="news-all-card-content">
                <p className="news-all-card-date">{news.date}</p>
                <h3>{news.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NewsAllPage;
